module.exports = __webpack_public_path__ + "img/DE05900.8f538517.png";